import React, { useState } from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import Snackbar from "@material-ui/core/Snackbar";
import SnackbarContent from "@material-ui/core/SnackbarContent";
import { useAnalyticsProvider } from "../index";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import NotificationsIcon from "@material-ui/icons/NotificationsNone";
import { useCookies } from "react-cookie";

const styles = theme => ({
  notification: {
    background: theme.palette.primary.main
  },
  snackbarContent: {
    maxWidth: "100%",
    paddingRight: theme.spacing(7)
  },
  message: {
    display: "flex",
    alignItems: "flex-start"
  },
  icon: {
    marginTop: theme.spacing(0.3333333333333333),
    marginRight: theme.spacing(3),
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "block"
    }
  },
  root: { marginRight: 0 },
  label: { color: "inherit" },
  checkbox: {
    color: "inherit"
  },
  checked: {
    color: "inherit"
  },
  action: {
    position: "absolute",
    top: theme.spacing(0.5),
    right: theme.spacing(0.5),
    margin: 0,
    padding: 0
  }
});

const OSSTermsOfServiceOptIn = ({ classes }) => {
  const [cookies, setCookie] = useCookies(["tos_agree"]);
  const [open, setOpen] = useState(true);
  const setTrackerData = useAnalyticsProvider();
  const variant = "notification";

  // Quick and dirty way to get the current root domain: https://stackoverflow.com/a/10438886
  const reversedHostnameElements = location.hostname.split(".").reverse();
  const rootDomain =
    "." + reversedHostnameElements[1] + "." + reversedHostnameElements[0];

  if (cookies && cookies.tos_agree === "true") {
    return null;
  }

  const handleClose = () => {
    setOpen(false);
  };

  const handleOnExited = () => {
    // Until we can persist this agreement in the DB, we will set a cookie:
    setCookie("tos_agree", true, {
      path: "/",
      domain: rootDomain,
      expires: new Date(2030, 0, 0)
    });
    setTrackerData({
      method: "event",
      category: "Terms of Service",
      action: "User agreed to TOS"
    });
  };

  return (
    <Snackbar
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      open={open}
      onExited={handleOnExited}
    >
      <SnackbarContent
        className={[classes[variant], classes.snackbarContent].join(" ")}
        classes={{ action: classes.action }}
        aria-describedby="tos-snackbar"
        message={
          <span id="tos-snackbar" className={classes.message}>
            <NotificationsIcon className={classes.icon} />
            <span>
              <b>Terms and Conditions: </b> Lorem ipsum dolor sit amet
              consectetur adipisicing elit. Fugit, ipsam suscipit nostrum rerum
              odio dolorum non libero molestiae sint vel ea cumque repellat rem
              ut optio corrupti cum delectus ex.
            </span>
          </span>
        }
        action={
          <IconButton color="inherit" onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        }
      />
    </Snackbar>
  );
};

export default withStyles(styles)(OSSTermsOfServiceOptIn);
